import LocalizedStrings from 'react-localization';

class CordovaCompatibleLocalizedStrings extends LocalizedStrings {
	setLanguage(language) {
		if (!language) {
			language = navigator.language || "en";
		}
		super.setLanguage(language);
	}
}

export const Strings = (function () {
	let instance;
	function createInstance(state = false) {
		let newInstance = new CordovaCompatibleLocalizedStrings({
			en: {}
		});

		return newInstance;
	}
	return {
		getInstance: function () {
			if (!instance) {
				instance = createInstance();
			}
			return instance;
		},
		destroyInstance: function () {
			instance = undefined;
			return instance;
		},
		newInstance: function (state) {
			instance = createInstance(state);
			return instance;
		}
	};
})();

const strings = Strings.getInstance();
export default strings